import type { NavConfigRefocusConfigAny, NavConfigRefocusTargetAny } from '@pressreader/navigation-types';
import type { WithHash } from '@pressreader/types';
import { extendObjectWithHash } from '@pressreader/utils';

const joinHashParts = (...parts: string[]): string => parts.join('/');

export const calculateRefocusConfigHash = (refocusConfig: NavConfigRefocusConfigAny): string => {
    return joinHashParts('c', refocusConfig.type, refocusConfig.id);
};

export const calculateRefocusTargetHash = (refocusTarget: NavConfigRefocusTargetAny): string => {
    return joinHashParts('t', refocusTarget.type, refocusTarget.refocusTarget.id);
};

export const extendRefocusTargetWithHash = <T extends NavConfigRefocusTargetAny>(refocusTarget: T): WithHash<T> => {
    return extendObjectWithHash(refocusTarget, calculateRefocusTargetHash(refocusTarget));
};

export const extendRefocusConfigWithHash = <T extends NavConfigRefocusConfigAny>(refocusConfig: T): WithHash<T> => {
    return extendObjectWithHash(refocusConfig, calculateRefocusConfigHash(refocusConfig));
};

export const areRefocusTargetsEqual = <T extends NavConfigRefocusTargetAny>(refocusTargetA: T, refocusTargetB: T): boolean => {
    return calculateRefocusTargetHash(refocusTargetA) === calculateRefocusTargetHash(refocusTargetB);
};

export const areRefocusConfigsEqual = <T extends NavConfigRefocusConfigAny>(refocusConfigA: T, refocusConfigB: T): boolean => {
    return calculateRefocusConfigHash(refocusConfigA) === calculateRefocusConfigHash(refocusConfigB);
};

export const isRefocusTargetMatchRefocusConfig = (refocusTarget: NavConfigRefocusTargetAny, refocusConfig: NavConfigRefocusConfigAny): boolean => {
    return refocusTarget.type === refocusConfig.type && refocusTarget.refocusTarget.id === refocusConfig.refocusTarget.id;
};
